import { dataPinSlant } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPinSlant = /*#__PURE__*/createIcon(dataPinSlant)
export default IconPinSlant
